import { render, staticRenderFns } from "./BookAppearance.vue?vue&type=template&id=4940e17a"
import script from "./BookAppearance.vue?vue&type=script&lang=js"
export * from "./BookAppearance.vue?vue&type=script&lang=js"
import style0 from "./BookAppearance.vue?vue&type=style&index=0&id=4940e17a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports